<template>
  <div class="article-page-layout">
    <div class="pgnnp-header">
      <Paganiniplus />
    </div>
    <div ref="container" class="mk-container">
      <ArticlePanel :article="article" />
      <div v-if="!article" class="article-loading">
        <Loader v-if="!articleLoaded" />
        <CommonEmptyContent v-else-if="articleLoaded" :locale-key="'COMMON.EMPTY_CONTENT_TEXT'" />
      </div>
      <div v-else-if="article && article.id" class="article-container">
        <div class="container-left">
          <Breadcrumbs :breadcrumbs="breadcrumbs" />
          <template v-if="type === 'article'">
            <div class="article-cover">
              <img v-if="articleCoverLoaded && (article.cover || article.cover_file_link)" :src="article.cover || article.cover_file_link" :title="article.subject" :alt="article.subject">
              <div v-else-if="articleCoverLoaded && !article.cover && !article.cover_file_link" />
              <div v-else :class="{'skeleton-cover': !articleCoverLoaded}" class="cover" />
            </div>
          </template>
          <template v-else>
            <ArticleHeader :cover-src="coverSrc" :title="article.subject" :volume="article.volume" :authors="authors" />
          </template>
          <ArticleContent :article="article" :authors="authors" :type="type" :is-limit="isLimit" />
          <ArticleSubscribeBlock v-if="isLimit" />
          <ArticleTagList :tag-list="tagList" />
          <div class="article-seperator">
            <!--  -->
          </div>
          <ArticleAuthorList :authors="authors" />
          <div class="article-seperator">
            <!--  -->
          </div>
          <!-- <ArticleRecommend /> -->
          <ArticleList :block-title="$t('ARTICLE.THE_RECOMMEND_ARTICLES')"
                       :article-data="recommendArticleList"
                       block-type="recommend"
                       class="article-recommend"
          />
        </div>
        <div ref="stickyBlock" class="container-right">
          <ArticleList :block-title="$t('ARTICLE.THE_POPULAR_ARTICLES')"
                       :article-data="popularArticles"
                       block-type="popular"
                       class="article-popular"
          />
          <div class="edm-subscription-container">
            <h3 class="edm-subscription-title">
              隨時補充國內外最新古典樂時事
            </h3>
            <MCSignupForm />
          </div>
        </div>
        <FacebookComment v-if="!isCN" />
      </div>
    </div>
    <Paganiniplus />
  </div>
</template>
<script>
import ArticleService from '@/assets/services/ArticleService'
import TagService from '@/assets/services/TagService'
import AuthorService from '@/assets/services/AuthorService'
import LoggerService from '@/assets/services/LoggerService'

import Paganiniplus from '@/components/tsp/Paganiniplus'
import Loader from '@/components/common/Loader'
import Breadcrumbs from '@/components/common/Breadcrumbs'
import FacebookComment from '@/components/common/FacebookComment'
import CommonEmptyContent from '@/components/common/DummyStatus/CommonEmptyContent'

import ArticleHeader from '@/components/article/ArticleHeader'
import ArticleContent from '@/components/article/ArticleContent'
import ArticleSubscribeBlock from '@/components/article/ArticleSubscribeBlock'
import ArticleTagList from '@/components/article/ArticleTagList'
import ArticleAuthorList from '@/components/article/ArticleAuthorList'
import ArticleList from '@/components/article/ArticleList'
import ArticlePanel from '@/components/article/ArticlePanel'
import MCSignupForm from '@/components/common/MCSignupForm'

export default {
  name: 'ArticlePageLayout',
  components: {
    Paganiniplus,
    Loader,
    Breadcrumbs,
    FacebookComment,
    CommonEmptyContent,
    ArticleHeader,
    ArticleContent,
    ArticleSubscribeBlock,
    ArticleTagList,
    ArticleAuthorList,
    ArticleList,
    ArticlePanel,
    MCSignupForm
  },
  directives: {},
  props: {
    article: {
      type: Object,
      default: () => {
        return {}
      }
    },
    articleLoaded: {
      type: Boolean,
      default: false
    },
    articleCoverLoaded: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: '',
      validator: function (value) {
        return ['article', 'periodicalArticle'].indexOf(value) !== -1
      }
    },
    isLimit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isCN: this.$isCN,
      authors: [],
      tagList: [],
      // articleLoaded: false,
      // For log
      articleSessionId: '',
      timer: 0,
      // For sticky
      debounceTimer: 0,
      orinScrollTop: 0,
      isSticky: false,
      // recommend
      recommendNum: 4,
      recommendArticleList: [],
      popularArticles: []
    }
  },
  metaInfo() {
    return {
      title: this.title,
      meta: [
        // ...this.$route.meta.metaInfo.meta,
        { vmid: 'name', name: 'name', content: this.title },
        { vmid: 'description', name: 'description', content: this.description },
        { vmid: 'image', name: 'image', content: this.cover },
        { vmid: 'keywords', name: 'keywords', content: this.keywords },
        { vmid: 'og:title', name: 'og:title', content: this.title },
        { vmid: 'og:description', name: 'og:description', content: this.description },
        { vmid: 'og:image', name: 'og:image', content: this.cover },
        { vmid: 'og:url', name: 'og:url', content: this.canonicalURL }
      ],
      link: [
        { vmid: 'canonical', rel: 'canonical', href: this.canonicalURL },
        { vmid: 'image_src', rel: 'image_src', href: this.cover }
      ],
      __dangerouslyDisableSanitizers: ['script'],
      script: [{ innerHTML: JSON.stringify(this.structuredData), type: 'application/ld+json' }]
    }
  },
  computed: {
    title() {
      const titlePostfix = `${this.$t('READ.TITLE')} | MUZIK AIR`
      return this.article && this.article.subject
        ? `${this.article.subject} | ${titlePostfix}`
        : titlePostfix
    },
    description() {
      return this.article && this.article.short_content
        ? this.article.short_content.slice(0, 197) + '...'
        : this.title
    },
    cover() {
      return this.article && this.article.cover
        ? this.article.cover
        : `https://${process.env.VUE_APP_MUZIK_READ}.${process.env.VUE_APP_MUZIK_DOMAIN}/img/cover-social/read.png`
    },
    coverSrc() {
      return this.type === 'periodicalArticle' && this.article.volume
        ? this.article.volume.file_link
        : this.article.cover || this.article.cover_file_link
    },
    canonicalURL() {
      return this.article && this.article.id
        ? `https://${process.env.VUE_APP_MUZIK_READ}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/articles/${this.article.id}`
        : `https://${process.env.VUE_APP_MUZIK_READ}.${process.env.VUE_APP_MUZIK_DOMAIN}`
    },
    keywords() {
      let keywordsAry = []
      if (this.article && this.article.subject) {
        keywordsAry.push(this.article.subject)
        // keywordsAry.push(this.article.short_content)
        if (this.authors) {
          this.authors.forEach(author => {
            keywordsAry.push(author.name)
          })
        }
        if (this.tagList) {
          this.tagList.forEach(tag => {
            keywordsAry.push(tag.name)
          })
        }
      }
      return keywordsAry.join(', ') || this.$t('ARTICLE.TITLE')
    },
    structuredData() {
      return [
        {
          '@context': 'http://schema.org',
          '@type': 'Article',
          '@id': this.canonicalURL,
          'mainEntityOfPage': {
            '@type': 'WebPage',
            '@id': `https://${process.env.VUE_APP_MUZIK_READ}.${process.env.VUE_APP_MUZIK_DOMAIN}`
          },
          'headline': this.title,
          'name': this.title,
          'image': this.cover,
          'keywords': this.keywords,
          'url': this.canonicalURL,
          'datePublished': (this.article && this.article.published_at) || '',
          // 'dateCreated': (this.article && this.article.published_at) || '',
          'dateModified': (this.article && this.article.published_at) || '',
          'author': {
            '@type': 'Person',
            'name': (this.authors && this.authors.map(author => author.name).join(', ')) || ''
          },
          'publisher': {
            '@type': 'Organization',
            'name': 'MUZIK AIR',
            'logo': {
              '@type': 'ImageObject',
              'url': `https://${process.env.VUE_APP_MUZIK_READ}.${process.env.VUE_APP_MUZIK_DOMAIN}/img/cover-social/read.png`
            }
          },
          'description': this.description,
          'articleBody': this.article && this.article.html_content
        },
        {
          '@context': 'http://schema.org',
          '@type': 'BreadcrumbList',
          'itemListElement': [{
            '@type': 'ListItem',
            'position': 1,
            'item': {
              '@id': `https://${process.env.VUE_APP_MUZIK_READ}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/`,
              'name': this.$t('READ.TITLE')
            }
          }
          // ,{
          //   '@type': 'ListItem',
          //   'position': 2,
          //   'item': {
          //     '@id': metaURL,
          //     'name': this.article && this.article.subject
          //   }
          // }
          ]
        }
      ]
    },
    clientWidth() {
      return this.$store.state.clientWidth
    },
    breadcrumbs() {
      const breadcrumbsAry = [{ routeName: 'index', localeLabel: 'READ.TITLE', redirectPath: '' }]
      if (this.article && this.article.subject) {
        breadcrumbsAry.push({ routeName: '', localeLabel: this.article.subject, redirectPath: '' })
      } else {
        breadcrumbsAry.push({ routeName: '', localeLabel: 'ARTICLE.TITLE', redirectPath: '' })
      }
      return breadcrumbsAry
    },
    isStickyRightBlock() {
      return this.clientWidth >= 1024
    },
    initStickyBlockOffsetTop() {
      let bodyRect = document.body.getBoundingClientRect()
      let elemRect = this.$refs.stickyBlock.getBoundingClientRect()
      return elemRect.top - bodyRect.top
    }
  },
  watch: {
    article(newValue) {
      if (newValue && newValue.id) {
        this.getArticleTags(newValue.id)
        this.getAuthor(newValue.id)
        // Log user action, after article done
        this.generateSessionId(newValue.id)
        this.startLogUserAction()
        // this.articleLoaded = true
      } else {
        // this.articleLoaded = true
      }
    }
  },
  created() {
    this.getRecommendArticles()
    this.getArticlePopular()
  },
  mounted() {
    if (this.isStickyRightBlock) window.addEventListener('scroll', this.debounceWithScroll)
    window.addEventListener('resize', this.onScrollInit)
  },
  updated() {},
  beforeDestroy() {
    clearInterval(this.timer)
    window.removeEventListener('scroll', this.debounceWithScroll)
    window.removeEventListener('resize', this.onScrollInit)
  },
  methods: {
    async getRecommendArticles() {
      const params = {
        'per_page': this.recommendNum,
        'page': 1
      }
      const recommendArticles = await ArticleService.getArticleByRecommend(params)
      if (recommendArticles.data) {
        this.recommendArticleList = recommendArticles.data
      }
    },
    async getArticlePopular() {
      const article = await ArticleService.getArticlesByPopular()
      if (article && article.data) {
        this.popularArticles = article.data.slice(0, 4)
      }
    },
    async getArticleTags(articleId) {
      this.tagList.forEach(itemex => this.tagList.pop())
      let tempTagList = []
      if (!this.article.tags) {
        const tagListData = await TagService.getTagByArticleId(articleId)
        if (tagListData) {
          tempTagList = tagListData
        }
      } else {
        tempTagList = this.article.tags
      }
      this.tagList = tempTagList
      // gtag event
      this.tagList.forEach(tag => {
        this.$store.dispatch('GTAG_EVENT', {
          action: 'view_article_tags',
          data: {
            'event_category': 'tag',
            'event_label': `${tag.name} ${tag.id}`,
            'non_interaction': true
          }
        })
      })
    },
    async getAuthor(articleId) {
      if (!this.article.authors) {
        const auhtorsData = await AuthorService.getAuthorByArticleId(articleId)
        if (auhtorsData) {
          this.authors = auhtorsData
        }
      } else {
        this.authors = this.article.authors
      }
      // gtag event
      // const authorIDs = this.authors.map(author => author.id).join(', ')
      this.authors.forEach(author => {
        this.$store.dispatch('GTAG_EVENT', {
          action: 'view_article_authors',
          data: {
            'event_category': 'author',
            'event_label': `${author.name} ${author.id}`,
            'non_interaction': true
          }
        })
      })
    },
    // Generate Session Id
    generateSessionId(id) {
      // Plan A
      // const articleId = id
      // const fingerprint = window.localStorage.getItem('fingerprint') || ''
      // const time = new Date().getTime().toString()
      // const hashCode = btoa(articleId + fingerprint + time)
      // Plan B:
      const hashCode = Math.random().toString(36).substr(2)
      this.articleSessionId = hashCode
    },
    // Log
    startLogUserAction() {
      this.logRecord() // Initial time
      let count = (10 * 60) / 5 // Only log 10 min (120 times)
      this.timer = setInterval(() => {
        this.logRecord()
        count--
        if (count === 0) clearInterval(this.timer)
      }, 5000)
    },
    logRecord() {
      const articleId = this.article ? this.article.id : ''
      const articleSessionId = this.articleSessionId ? this.articleSessionId.slice(0, 36) : ''
      // post api to server
      if (articleId && articleSessionId) {
        const params = {
          articleId,
          articleSessionId,
          userId: articleId,
          peopleCookieId: window.localStorage.getItem('fingerprint') || '',
          refer: document.referrer || this.$route.query.refer || '',
          agent: window.navigator.userAgent,
          isSuggested: this.$route.query.isSuggested || 0, // is_suggested
          readRatio: Number.parseInt(this.countPagePercentage() * 100)
        }
        // console.log('readPercentage', params.readPercentage)
        LoggerService.logUserArticleAction(params)
      }
    },
    // For Sticky Block
    debounceWithScroll() {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer)
      }
      this.debounceTimer = setTimeout(() => {
        this.onScroll()
      }, 10)
    },
    getStickyBlockTop(stickyBlockName) {
      let bodyRect = document.body.getBoundingClientRect()
      let elemRect = this.$refs[stickyBlockName].getBoundingClientRect()
      return elemRect.top - bodyRect.top
    },
    setStickyBlockStyle(name, position, top, bottom, transform) {
      const stickyBlock = this.$refs[name]
      stickyBlock.style.position = position || ''
      stickyBlock.style.top = top || ''
      stickyBlock.style.bottom = bottom || ''
      stickyBlock.style.transform = transform || ''
    },
    onScrollInit () {
      if (this.isStickyRightBlock) {
        window.addEventListener('scroll', this.debounceWithScroll)
      } else {
        this.setStickyBlockStyle('stickyBlock')
        window.removeEventListener('scroll', this.debounceWithScroll)
      }
    },
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      const isScrollDown = this.orinScrollTop < scrollTop
      const stickyBlock = this.$refs.stickyBlock
      const stickyBlockHeight = stickyBlock.clientHeight
      const currentStickyBlockTop = this.getStickyBlockTop('stickyBlock')
      const containerBottom = this.$refs.container.clientHeight - window.innerHeight + this.initStickyBlockOffsetTop
      this.orinScrollTop = scrollTop
      // console.log('scrollTop: ', scrollTop, 'window.pageYOffset: ', window.pageYOffset)
      // console.log('stickyBlockHeight: ', stickyBlockHeight, 'stickyBlockTop: ', currentStickyBlockTop)
      // console.log('containerBottom: ', containerBottom)
      if (isScrollDown) {
        // Scroll Down
        if (scrollTop > (containerBottom - 20)) {
          this.setStickyBlockStyle('stickyBlock', 'absolute', '', '142px', 'translate3d(0px, 0px, 0px)')
        } else if (scrollTop > (stickyBlockHeight + currentStickyBlockTop - window.innerHeight)) {
          this.setStickyBlockStyle('stickyBlock', 'fixed', '', '15px', 'translate3d(0px, 0px, 0px)')
          this.isSticky = true
        }
      } else {
        // Scroll Top
        if (this.isSticky && scrollTop < (containerBottom - 120)) {
          const transformY = (scrollTop + window.innerHeight - stickyBlockHeight - this.initStickyBlockOffsetTop)
          this.isSticky = false
          this.setStickyBlockStyle('stickyBlock', '', '', '', 'translate3d(0px, ' + transformY + 'px, 0px)')
        } else if (scrollTop < this.initStickyBlockOffsetTop) {
          this.setStickyBlockStyle('stickyBlock')
        } else if (scrollTop < currentStickyBlockTop) {
          this.setStickyBlockStyle('stickyBlock', 'fixed', '0px', '', 'translate3d(0px, 0px, 0px)')
        }
      }
    },
    //
    countPagePercentage() {
      const scrollTop = window.pageYOffset // document.body.scrollTop;
      const windowHeight = window.innerHeight
      const documentHeight = document.documentElement.scrollHeight
      if (documentHeight <= windowHeight) {
        // No scroller indeed, or page not render yet
        return 0
      } else {
        const pagePercentage = scrollTop / (documentHeight - windowHeight)
        return pagePercentage
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@keyframes cover-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.article-page-layout {
  position: relative;
  margin-bottom: 36px; // pgnnp
}
.mk-container{
  padding: 0 0 0 104px;
}
.article-container {
  margin: 0 auto;
  overflow: hidden;
  .container-left{
    display: inline-block;
    overflow: hidden;
    float: left;
    width: calc(100% - 281px);
    border-right: 1px solid $grey-ec;
    padding-right: 106px;
  }
  .container-right{
    display: inline-block;
    width: 281px;
    padding: 0 35px;
  }
}
.article-loading {
  max-width: 1024px;
  margin: 70px auto;
  text-align: center;
}
.article-cover {
  .cover {
    width: 100%;
    height: 390px;
    border-radius: 12px;
    background-color: $grey-ec;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
  img {
    width: 100%;
    animation: cover-fade-in 1s ease-in-out 0s 1 forwards;
  }
}

.article-seperator {
  border-bottom: solid 1px $grey-ec;
}

@mixin container-right-title {
  font-size: 24px;
  font-weight: 500;
  line-height: 1.63;
  color: $grey-50;
  margin-bottom: 16px;
}

.pgnnp-header {
  margin-top: 24px;
}

.fb-comments-wrapper{
  width: calc(100% - 281px);
  padding-right: 106px;
  border-right: 1px solid $grey-ec;
  &:before{
    content: "";
    display: block;
    clear: both;
  }
}

.edm-subscription-container {
  .edm-subscription-title {
    @include container-right-title;
  }
}

@media only screen and (min-width: 1440px) {}
@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {}
@media only screen and (max-width: 1023.98px) {
  .mk-container{
    padding: 0 36px;
  }
  .pgnnp-header{
    margin-bottom: 24px;
  }
  .article-container {
    margin-top: 24px;
    .container-left{
      width: 100%;
      float: none;
      padding: 0;
      border: 0;
    }
    .container-right{
      width: 100%;
      padding: 0;
    }
  }
  .fb-comments-wrapper{
    width: 100%;
    padding: 0;
    border: 0;
    margin-top: 24px;
  }
  .edm-subscription-title {
    display: none;
  }
}
@media only screen and (max-width: 767.98px) {
  .article-container {
    width: 100%;
  }
  .article-info {
    margin-bottom: 24px;
  }
}
</style>
